import React, { useCallback } from "react";
import ConfirmarAnaliseDialog from "./ConfirmarAnaliseDialog";
import { useSelector, useDispatch } from "react-redux";
import { getChecklist } from "../../../../selectors/documentos.selectors";
import { actions } from "../../../../reducers/propostas.actions";
import validators from "../../../../utils/validators";
import { useForm } from "react-hook-form";

const ConfirmarAnaliseDialogConnected = ({
  handleClose,
  dados: { open, ...otherData },
}) => {
  const dispatch = useDispatch();
  const { analysing } = useSelector(getChecklist);

  const handleSubmit = useCallback(
    (values) => {
      dispatch(
        actions.atuarAnalisarDocumento.request({
          ...otherData,
          ...values,
          handleClose,
        })
      );
    },
    [dispatch, otherData, handleClose]
  );

  const rules = {
    motivo: validators.string({
      required:
        otherData?.situacaoAnalise === "S" ||
        otherData?.situacaoAnalise === "D",
    }),
  };
  const initialValues = {
    motivo: "",
  };
  const formProps = {
    ...useForm(),
    rules,
    initialValues,
  };

  return (
    <ConfirmarAnaliseDialog
      handleSubmit={handleSubmit}
      open={open}
      dados={otherData}
      formProps={formProps}
      handleClose={handleClose}
      submitting={analysing}
    />
  );
};

export default ConfirmarAnaliseDialogConnected;
